<script>
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";
  import SvelteTooltip from "svelte-tooltip";

  import AlertModal from "./AlertModal.svelte";

  let alertModal = null;

  export let diaries = null;
  export let intolerances = null;

  const dispatch = createEventDispatcher();

  export let activeMonth = null;
  export let activeYear = null;

  let activeIntolerancesList = null;

  onMount(() => {
    dispatch("calendarLoaded", {});

    if (localStorage.getItem("activeIntolerancesList"))
      activeIntolerancesList =
        localStorage.getItem("activeIntolerancesList") === "true";
    else activeIntolerancesList = true;

    const showIntolerancesLi = document.getElementById("showIntolerancesLi");
    if (activeIntolerancesList) showIntolerancesLi.classList.add("displaying");
    else showIntolerancesLi.classList.remove("displaying");

    window.onscroll = function () {
      checkFooterPosition();
    };
  });
  window.addEventListener("load", function () {
    checkFooterPosition();
  });

  function changeMonth(direction) {
    if (
      direction === 1 &&
      document.getElementById("next").classList.contains("disabled")
    )
      return;

    let newDate;
    const date = moment(
      activeYear + "-" + (activeMonth + 1) + "-01",
      "YYYY-MM-DD"
    );

    if (direction === -1) {
      newDate = moment(date).subtract(1, "M");
    } else {
      newDate = moment(date).add(1, "M");
    }

    activeMonth = newDate.month();
    activeYear = newDate.year();

    fillCalendar();
  }

  function resetMonth() {
    activeMonth = moment().month();
    activeYear = moment().year();

    fillCalendar();
  }

  function getDaysInMonth() {
    const days = [];
    let momentDays = moment(
      activeYear + "-" + (activeMonth + 1),
      "YYYY-MM-DD"
    ).daysInMonth();

    while (momentDays) {
      const current = moment(
        activeYear + "-" + (activeMonth + 1),
        "YYYY-MM-DD"
      ).date(momentDays);
      days.push(current);
      momentDays--;
    }
    return days;
  }

  function removeChildren(id) {
    const node = document.getElementById(id);
    if (!node) return;
    while (node.firstChild) {
      node.removeChild(node.lastChild);
    }
  }

  function uploadDiaries() {
    var input = document.createElement("input");
    input.type = "file";
    input.onchange = (e) => {
      const file = e.target.files[0];
      const path = (window.URL || window.webkitURL).createObjectURL(file);

      var rawFile = new XMLHttpRequest();
      rawFile.overrideMimeType("application/json");
      rawFile.open("GET", path, true);
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4 && rawFile.status == "200") {
          let uploadedDiaries = {};
          try {
            uploadedDiaries = JSON.parse(rawFile.response);
          } catch (e) {
            alert($_("calendar.upload.errorParsing"));
          }
          if (
            uploadedDiaries instanceof Object &&
            Object.values(uploadedDiaries).every(
              (diary) => diary._id && diary._id.includes("diary_")
            )
          ) {
            dispatch("uploadFoodDiaries", {
              uploadedDiaries,
            });
          } else {
            alert($_("calendar.upload.errorParsing"));
            return;
          }
        }
      };
      rawFile.send(null);
    };
    input.click();
  }

  function downloadDiaries() {
    var a = document.createElement("a");
    var file = new Blob([JSON.stringify(diaries, null, 2)], {
      type: "application/json",
    });
    a.href = URL.createObjectURL(file);
    a.download = "fooddiaries.json";
    a.click();
  }

  function clearDiaries() {
    dispatch("clearDiaries", {});
    alertModal.hide();
  }

  function showIntolerances() {
    activeIntolerancesList = !activeIntolerancesList;

    localStorage.setItem("activeIntolerancesList", activeIntolerancesList);

    const showIntolerancesLi = document.getElementById("showIntolerancesLi");
    if (activeIntolerancesList) {
      showIntolerancesLi.classList.add("displaying");
      setTimeout(function () {
        fillIntolerances();
      }, 100);
    } else {
      showIntolerancesLi.classList.remove("displaying");
      setFooterBottom();
    }
  }

  function checkFooterPosition() {
    const footer = document.getElementById("footer");
    if (document.body.scrollHeight > document.body.clientHeight) {
      setFooterBehind();
    } else {
      setFooterBottom();
    }
  }

  function setFooterBehind() {
    const footer = document.getElementById("footer");
    footer.style.position = "initial";
  }

  function setFooterBottom() {
    const footer = document.getElementById("footer");
    footer.style.position = "absolute";
  }

  function portfolio() {
    window.open("https://www.vincentriche.com", "_blank");
  }

  export function fillCalendar() {
    removeChildren("days");
    removeChildren("title1");
    removeChildren("title2");

    const calendarDays = document.getElementById("days");
    const calendarNext = document.getElementById("next");
    const calendarTitle1 = document.getElementById("title1");
    const calendarTitle2 = document.getElementById("title2");

    const textNodeTitle1 = document.createTextNode(
      $_(
        "calendar.calendar.month." +
          moment().month(activeMonth).format("MMMM").toLowerCase()
      )
    );
    calendarTitle1.appendChild(textNodeTitle1);
    const textNodeTitle2 = document.createTextNode(activeYear);
    calendarTitle2.appendChild(textNodeTitle2);
    const days = getDaysInMonth().reverse();
    let firstDayCount = days[0].day() - 1;
    if (firstDayCount < 0) firstDayCount += 7;

    for (let i = 0; i < firstDayCount; i++) {
      const newNodeLi = document.createElement("LI");
      const newNodeDiv = document.createElement("div");
      newNodeLi.classList.add("invisible-date");
      newNodeDiv.classList.add("invisible-date");
      newNodeLi.onclick = () => {};
      const newTextNode = document.createTextNode("0");
      newNodeDiv.appendChild(newTextNode);
      newNodeLi.appendChild(newNodeDiv);
      calendarDays.appendChild(newNodeLi);
    }

    if (moment().isSame(days[0], "month")) {
      calendarNext.classList.add("disabled");
    } else {
      calendarNext.classList.remove("disabled");
    }

    days.forEach((day) => {
      const date = day.date();
      const newNodeLi = document.createElement("LI");
      const newNodeDiv = document.createElement("div");

      let clickable = true;
      const index = moment(day).format("YYYY_MM_DD");

      if (
        diaries[index] &&
        diaries[index].red &&
        diaries[index].lunch &&
        diaries[index].diner
      ) {
        if (
          diaries[index].red.ingredients.length > 0 &&
          diaries[index].lunch.ingredients.length === 0 &&
          diaries[index].diner.ingredients.length === 0
        ) {
          newNodeLi.classList.add("red-filled-date");
        } else if (
          diaries[index].red.ingredients.length === 0 &&
          diaries[index].lunch.ingredients.length > 0 &&
          diaries[index].diner.ingredients.length === 0
        ) {
          newNodeLi.classList.add("lunch-filled-date");
        } else if (
          diaries[index].red.ingredients.length === 0 &&
          diaries[index].lunch.ingredients.length === 0 &&
          diaries[index].diner.ingredients.length > 0
        ) {
          newNodeLi.classList.add("diner-filled-date");
        } else if (
          diaries[index].red.ingredients.length > 0 &&
          diaries[index].lunch.ingredients.length > 0 &&
          diaries[index].diner.ingredients.length === 0
        ) {
          newNodeLi.classList.add("red-lunch-filled-date");
        } else if (
          diaries[index].red.ingredients.length > 0 &&
          diaries[index].lunch.ingredients.length === 0 &&
          diaries[index].diner.ingredients.length > 0
        ) {
          newNodeLi.classList.add("red-diner-filled-date");
        } else if (
          diaries[index].red.ingredients.length === 0 &&
          diaries[index].lunch.ingredients.length > 0 &&
          diaries[index].diner.ingredients.length > 0
        ) {
          newNodeLi.classList.add("lunch-diner-filled-date");
        } else if (
          (diaries[index].red.ingredients.length === 0 &&
            diaries[index].red.feeling !== "") ||
          (diaries[index].lunch.ingredients.length === 0 &&
            diaries[index].lunch.feeling !== "") ||
          (diaries[index].diner.ingredients.length === 0 &&
            diaries[index].diner.feeling !== "")
        ) {
          newNodeLi.classList.add("completely-unfilled-date");
        } else {
          newNodeLi.classList.add("completely-filled-date");
          newNodeDiv.classList.add("completely-filled-date");
        }
      } else {
        newNodeLi.classList.add("completely-unfilled-date");
      }

      if (moment().isBefore(day, "days")) {
        clickable = false;
        newNodeLi.classList.add("unreached-date");
        newNodeDiv.classList.add("unreached-date");
      } else if (moment().isSame(day, "days")) {
        newNodeDiv.classList.add("active-date");
      } else {
        newNodeDiv.classList.add("unfilled-date");
      }

      if (clickable) {
        newNodeLi.onclick = () => {
          activeMonth = day.month();
          activeYear = day.year();
          dispatch("switchModule", {
            newModule: "diary",
            activeDate: day.format("YYYY-MM-DD"),
            openDiary: day.format("YYYY_MM_DD"),
            activeIntolerancesList,
          });
        };
      }

      const newTextNode = document.createTextNode(date);
      newNodeDiv.appendChild(newTextNode);
      newNodeLi.appendChild(newNodeDiv);
      calendarDays.appendChild(newNodeLi);
    });

    const calendar = document.getElementById("calendar");
    calendar.style.visibility = "visible";
  }

  export function fillIntolerances() {
    removeChildren("foodIntolerances");
    const foodIntolerances = document.getElementById("foodIntolerances");

    if (!foodIntolerances) return;

    intolerances.forEach((intolerance) => {
      const newNode = document.createElement("LI");
      const newTextNode = document.createTextNode(intolerance);
      newNode.appendChild(newTextNode);
      foodIntolerances.appendChild(newNode);
    });

    checkFooterPosition();
  }
</script>

<style>
  #header {
    width: 100%;
    padding: 30px 0 0 0;
  }

  h1 {
    display: inline-block;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 40px;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 5px;
    vertical-align: middle;
    color: var(--foreground-color);
  }

  .h2-title {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  h2 {
    display: inline-block;
    width: auto;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 3px;
  }

  .h2-icon {
    display: inline-block;
    width: auto;
    font-size: 18px;
    text-align: center;
    margin: 0 5px;
    padding: 0;
    letter-spacing: 3px;
  }

  .hr {
    width: 70%;
    height: 1px;
    margin: 25px auto 12.5px auto;
    background-color: var(--border-color);
  }

  .hr2 {
    margin: 25px auto 25px auto;
  }

  .calendar {
    visibility: hidden;
  }

  ul {
    list-style-type: none;
  }

  .tools {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    padding: 0;
  }

  .tools > :global(div) {
    display: flex;
    align-items: center;
    width: 40%;
  }

  .tools > :global(div):nth-child(1) {
    justify-content: flex-start;
  }

  .tools > :global(div):nth-child(2) {
    justify-content: flex-end;
  }

  .tools > :global(div li) {
    display: inline-block;
    width: 34px;
    height: 34px;
    margin: 0 1%;
    padding: 0;
    list-style-type: none;
    border-radius: 50%;
    box-shadow: 1px 1px 5px var(--shadow-color1);
    cursor: pointer;
  }

  .tools > :global(div li p) {
    display: block;
    width: 34px;
    height: 34px;
    margin: 0;
    padding: 9px 0;
    text-align: center;
    font-size: 15px;
    color: var(--background-color);
  }

  .tools :global(.orange-item) {
    background-color: var(--orange-color);
  }

  .tools :global(.blue-item) {
    background-color: var(--blue-color);
  }

  .tools :global(.red-item) {
    background-color: var(--red-color);
  }

  .tools :global(.green-item) {
    background-color: var(--green-color);
  }

  .tools :global(.gray-item) {
    background-color: var(--gray-color);
    cursor: auto;
  }

  .tools :global(.disabled-item) {
    cursor: unset;
  }

  .tools :global(.displaying) {
    background-color: var(--yellow-color);
  }

  .tools :global(.li-img) {
    padding: 0;
    background-color: var(--background-color);
  }

  .tools :global(.li-img img) {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .month {
    width: 90%;
    margin: -18px auto 0 auto;
    text-align: center;
  }

  .month ul {
    margin: 0;
    padding: 0;
  }

  .month ul li {
    width: 34px;
    height: 34px;
    margin: 20px 15px 0 15px;
    padding: 0;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: var(--background-color);
    border-radius: 50%;
    border: 2px solid var(--orange-color);
    background-color: var(--orange-color);
  }

  .month ul #title1,
  .month ul #title2 {
    width: 280px;
    margin: 30px auto 0 auto;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 1px;
    border-radius: 0;
    border: none;
    background-color: transparent;
    color: var(--foreground-color);
  }

  .month ul #title2 {
    margin: 5px auto 0 auto;
    font-size: 20px;
  }

  .month #previous,
  .month #next {
    float: left;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 30px;
    box-shadow: 1px 1px 5px var(--shadow-color1);
  }

  .month #next {
    float: right;
    letter-spacing: -1px;
  }

  .month :global(.disabled) {
    border-color: var(--gray-color);
    background-color: var(--gray-color);
    cursor: auto;
  }

  .weekdays {
    width: 90%;
    margin: 15px auto 0 auto;
    padding: 0;
  }

  .weekdays li {
    display: inline-block;
    width: 14.28%;
    margin: 0;
    padding: 5px 0;
    text-align: center;
    font-size: 18px;
  }

  .days {
    width: 90%;
    margin: 0 auto;
    padding: 0;
  }

  .days :global(li) {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    width: 8.1vw;
    height: 8.1vw;
    margin: 2.64%;
    padding: 0;
    list-style-type: none;
    border-radius: 50%;
    color: var(--background-color);
    box-shadow: 1px 1px 5px var(--shadow-color1);
  }

  .days :global(div) {
    width: 6vw;
    height: 6vw;
    text-align: center;
    font-size: 20px;
    border-radius: 50%;
    color: var(--background-color);
  }

  .days :global(.invisible-date) {
    color: transparent;
    background-color: transparent;
    box-shadow: none;
  }

  .days :global(.active-date) {
    background-color: var(--blue-color);
  }

  .days :global(.unfilled-date) {
    background-color: var(--green-color);
  }

  .days :global(.red-filled-date) {
    background: conic-gradient(
      var(--yellow-color) 120deg,
      var(--gray-color) 0 360deg
    );
  }

  .days :global(.red-lunch-filled-date) {
    background: conic-gradient(
      var(--yellow-color) 240deg,
      var(--gray-color) 0 360deg
    );
  }

  .days :global(.red-diner-filled-date) {
    background: conic-gradient(
      var(--yellow-color) 240deg,
      var(--gray-color) 0 360deg
    );
  }

  .days :global(.lunch-filled-date) {
    background: conic-gradient(
      var(--gray-color) 120deg,
      var(--yellow-color) 0 240deg,
      var(--gray-color) 0 360deg
    );
  }

  .days :global(.lunch-diner-filled-date) {
    background: conic-gradient(
      var(--gray-color) 120deg,
      var(--yellow-color) 0 360deg
    );
  }

  .days :global(.diner-filled-date) {
    background: conic-gradient(
      var(--gray-color) 240deg,
      var(--yellow-color) 0 360deg
    );
  }

  .days :global(.completely-filled-date) {
    background-color: var(--yellow-color);
  }

  .days :global(.completely-unfilled-date) {
    background-color: var(--gray-color);
  }

  .days :global(.unreached-date) {
    background-color: var(--gray-color);
    cursor: auto;
  }

  .infos {
    display: block;
    width: 80%;
    margin: 0 auto 5px auto;
    font-size: 15px;
    line-height: 15px;
    font-style: italic;
    text-align: center;
    color: var(--infos-color);
  }

  #foodIntolerances {
    display: list-item;
    width: 80%;
    margin: 15px auto;
    columns: 2;
    list-style-type: initial;
    list-style-position: inside;
  }

  #foodIntolerances :global(li) {
    padding: 1px 0;
    text-align: left;
    font-size: 17px;
  }

  #footer {
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 1% 0 0.5% 0;
    width: 100%;
    height: auto;
  }

  #footer p,
  #footer :global(a) {
    position: initial;
    width: auto;
    color: var(--main-text-color);
    text-align: center;
    font-size: 4vw;
  }
  #footer :global(a) {
    text-decoration: underline;
  }

  @media (min-width: 1024px) {
    li {
      cursor: pointer;
    }

    h2 {
      font-size: 22px;
    }

    .tools,
    .month,
    .weekdays,
    .days {
      width: 60%;
    }

    .tools :global(li),
    .month #previous,
    .month #next,
    .days :global(li) {
      transition: box-shadow 0.3s ease-in-out;
    }

    .tools :global(li:hover),
    .month #previous:hover,
    .month #next:hover,
    .days :global(li:hover) {
      box-shadow: 1px 1px 8px var(--shadow-color2);
    }

    .tools :global(.gray-item),
    .month :global(.disabled),
    .days :global(.unreached-date) {
      transition: none !important;
    }

    .tools :global(.gray-item:hover),
    .month :global(.disabled:hover),
    .days :global(.unreached-date:hover) {
      box-shadow: 1px 1px 5px var(--shadow-color1) !important;
    }

    .days :global(div.unreached-date:hover) {
      box-shadow: none !important;
    }

    .weekdays li {
      font-size: 26px;
    }

    .days :global(li) {
      width: 3.5vw;
      height: 3.5vw;
      margin: 4.186%;
      cursor: pointer;
    }

    .days :global(div) {
      width: 2.5vw;
      height: 2.5vw;
      cursor: pointer;
    }

    .infos {
      width: 60%;
      font-size: 19px;
      margin-top: 5px;
    }

    #foodIntolerances {
      width: 60%;
    }

    #foodIntolerances :global(li) {
      font-size: 20px;
    }

    #footer p,
    #footer :global(a) {
      position: initial;
      font-size: 1.1vw;
    }
  }
</style>

<svelte:options accessors={true} />
<div id="header">
  <h1 id="title">{$_('calendar.title')}</h1>
</div>

<div class="hr" />

<div id="calendar" class="calendar">
  <ul id="tools" class="tools">
    <div>
      <li on:click={() => portfolio()} class="red-item">
        <SvelteTooltip tip={$_('calendar.tooltip.portfolio')} bottom>
          <p class="fas fa-briefcase" />
        </SvelteTooltip>
      </li>
    </div>

    <div>
      <li on:click={() => alertModal.show()} class="red-item">
        <SvelteTooltip tip={$_('calendar.tooltip.trash')} bottom>
          <p class="fas fa-trash" />
        </SvelteTooltip>
      </li>

      <li on:click={() => downloadDiaries()} class="orange-item">
        <SvelteTooltip tip={$_('calendar.tooltip.download')} bottom>
          <p class="fas fa-download" />
        </SvelteTooltip>
      </li>

      <li on:click={() => uploadDiaries()} class="orange-item">
        <SvelteTooltip tip={$_('calendar.tooltip.upload')} bottom>
          <p class="fas fa-upload" />
        </SvelteTooltip>
      </li>

      <li
        on:click={() => showIntolerances()}
        class="green-item displaying"
        id="showIntolerancesLi">
        <SvelteTooltip
          tip={!activeIntolerancesList ? $_('calendar.tooltip.intolerances1') : $_('calendar.tooltip.intolerances2')}
          bottom>
          <p class="fas fa-fish" />
        </SvelteTooltip>
      </li>
    </div>
  </ul>

  <div class="month">
    <ul>
      <li
        id="previous"
        on:click={() => changeMonth(-1)}
        class="fas fa-angle-left" />
      <li
        id="next"
        on:click={() => changeMonth(1)}
        class="fas fa-angle-right" />
      <li id="title1" on:click={() => resetMonth(-1)} />
      <li id="title2" on:click={() => resetMonth(-1)} />
    </ul>
  </div>

  <ul class="weekdays">
    <li>{$_('calendar.calendar.weekday.monday')}</li>
    <li>{$_('calendar.calendar.weekday.tuesday')}</li>
    <li>{$_('calendar.calendar.weekday.wednesday')}</li>
    <li>{$_('calendar.calendar.weekday.thursday')}</li>
    <li>{$_('calendar.calendar.weekday.firday')}</li>
    <li>{$_('calendar.calendar.weekday.saturday')}</li>
    <li>{$_('calendar.calendar.weekday.sunday')}</li>
  </ul>

  <ul id="days" class="days" />
</div>

{#if activeIntolerancesList}
  <div class="hr hr2" />
  <div class="h2-title">
    <p class="fas fa-fish h2-icon" />
    <h2>{$_('calendar.title2')}</h2>
    <p class="fas fa-fish h2-icon" />
  </div>
  <p class="infos">{$_('calendar.infos.intolerances')}</p>

  <ul id="foodIntolerances" />
{/if}

<footer id="footer">
  <p>
    {@html $_('app.copyright')}
  </p>
</footer>

<AlertModal bind:this={alertModal}>
  <h3 class="title">{$_('calendar.alert-modal.title')}</h3>
  <p class="description">{$_('calendar.alert-modal.description')}</p>
  <div class="footer">
    <button
      on:click={() => alertModal.hide()}>{$_('calendar.alert-modal.cancel')}</button>
    <button
      on:click={() => clearDiaries()}>{$_('calendar.alert-modal.validate')}</button>
  </div>
</AlertModal>
